<template>
	<div class="ac" :style="style">
		<div class="ac__content" ref="content">
			<slot />
		</div>
	</div>
</template>

<script>
const CONFIG = { childList: true, subtree: true }

export default {
	name: 'AdaptiveContainer',
	props: {
		speed: {
			type: String,
			default: '0.3s'
		}
	},
	data() {
		return {
			height: -1,
			observer: null
		}
	},
	computed: {
		style() {
			if (this.height === -1) return undefined
			return {
				height: this.height + 'px',
				transitionDuration: this.speed
			}
		}
	},
	methods: {
		onReady({ target }) {
			if (target.readyState === 'complete') this.measure()
		},
		measure() {
			this.height = this.$refs.content.getBoundingClientRect().height
		}
	},
	created() {
		// Check for MutationObserver support
		if (window.MutationObserver) {
			this.observer = new MutationObserver(this.measure)
		}
	},
	mounted() {
		if (this.observer) {
			// Initial measure and watch content
			this.measure()
			this.observer.observe(this.$refs.content, CONFIG)

			// Re-measure on resize and document ready
			window.addEventListener('resize', this.measure)
			document.addEventListener('readystatechange', this.onReady)
		}
	},
	beforeDestroy() {
		if (this.observer) {
			this.observer.disconnect()
			window.removeEventListener('resize', this.measure)
			document.removeEventListener('readystatechange', this.onReady)
		}
	}
}
</script>

<style lang="scss" scoped>
.ac {
	position: relative;
	transition-property: height;
	transition-timing-function: ease-out;

	&,
	&__content {
		overflow: hidden;
	}
}
</style>
